import api from "../utils/api";
import { PROFILE } from "../constants/routes";
import localStorageService from "./localStorageService";

export type UserProfileResponse = {
  username: string;
  email: string;
  full_name: string;
  designation: string;
};

class ProfileService {
  public getProfile = async (username: string, email?: string) => {
    try {
      const userInfo = localStorageService.getUserInfo();
      const token = userInfo?.token;

      const headers: Record<string, string> = {
        Accept: "application/json",
      };
      if (token) headers.Authorization = `Bearer ${token}`;

      const params = new URLSearchParams();
      params.set("username", username);
      if (email) params.set("email", email);

      const response = await api.get<UserProfileResponse>(
        `${PROFILE}?${params.toString()}`,
        { headers }
      );
      return response;
    } catch (error: any) {
      return error?.response || error;
    }
  };
}

const profileService = new ProfileService();
export default profileService;
